import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ArticleCards from './components/ArticleCards';
import ExpertReview from './components/ExpertReview';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://yoybuyspreadsheet.lol/#organization',
      name: 'YOYBUY Spreadsheet',
      url: 'https://yoybuyspreadsheet.lol/',
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
      },
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://yoybuyspreadsheet.lol/#website',
      url: 'https://yoybuyspreadsheet.lol/',
      name: 'YOYBUY Spreadsheet',
      description: 'YOYBUY Spreadsheet — профессиональный инструмент для заказа товаров из Китая. Таблицы агентов, сравнение платформ, руководство по покупкам через 1688 и Taobao.',
      publisher: {
        '@id': 'https://yoybuyspreadsheet.lol/#organization',
      },
      inLanguage: 'ru-RU',
    },
    {
      '@type': 'WebPage',
      '@id': 'https://yoybuyspreadsheet.lol/#webpage',
      url: 'https://yoybuyspreadsheet.lol/',
      name: 'YOYBUY Spreadsheet — Лучший агент для заказа товаров из Китая',
      isPartOf: {
        '@id': 'https://yoybuyspreadsheet.lol/#website',
      },
      about: {
        '@id': 'https://yoybuyspreadsheet.lol/#organization',
      },
      datePublished: '2026-07-04',
      dateModified: '2026-07-04',
      inLanguage: 'ru-RU',
    },
  ],
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Hero />
      <CategorySection />
      <ArticleCards />
      <ExpertReview />
      <CTABanner />
      <Footer />
    </main>
  );
}